import { Injectable } from '@angular/core';
import { GLOBAL } from './../global';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NumberFormatterCallbackFunction } from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private url:string;
  userToken = localStorage.getItem('token').slice(1).slice(0,-1);

  constructor(private _http:HttpClient) {
    this.url = GLOBAL.url + 'Dashboard';
  }

  getDashboardGeneral(rol:string, empresaID:number, flagExt:string){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardGeneral?rol=' + rol + '&empresaID=' + empresaID + '&flagExt=' + flagExt, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getDashboardGeneral_Mandatorios(rol:string, empresaID:number, flagExt:string){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardGeneral_Mandatorios?rol=' + rol + '&empresaID=' + empresaID + '&flagExt=' + flagExt, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getDashboardAreas(flagExt:string){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardAreas?flagExt=' + flagExt, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getDashboardDetalle(rol:number,tp:number,tm:string,tl:number,flagExt:string){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardDetalle?rol=' + rol + '&tp=' + tp + '&tm=' + tm + '&tl=' + tl + '&flagExt=' + flagExt, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getRole(rol:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getRole?rol=' + rol, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getDashboardDetalleEmpresa(rol:number, empresaID:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardDetalleEmpresa?rol=' + rol + '&empresaID=' + empresaID, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getDashboardResumen(rol:number, tp:number, tm:String, tl:number, flagExt:string){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getDashboardResumen?rol=' + rol + '&tp=' + tp + '&tm=' + tm + '&tl=' + tl + '&flagExt=' + flagExt, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }
  
  getReporteAdmin(empresaID:number, tm:String, status:String, itemID:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporteAdmin?empresaID=' + empresaID + '&tm=' + tm + '&status=' + status + '&itemID=' + itemID, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporteIngreso(desde:Date, hasta:Date, status:String){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporteIngreso?desde=' + desde + '&hasta=' + hasta + '&status=' + status, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_DirectorioGeneral(eliminado:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_DirectorioGeneral?eliminado=' + eliminado + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_CodigoConducta(eliminado:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_CodigoConducta?eliminado=' + eliminado + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_DocumentosAuditoria(eliminado:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_DocumentosAuditoria?eliminado=' + eliminado + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_OpinionCumplimiento(anio:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_OpinionCumplimiento?anio=' + anio, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_StatusCarga(status:String, eliminado:number, itemID:String, ){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_StatusCarga?status=' + status + '&eliminado=' + eliminado + '&itemID=' + itemID, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_StatusContrato(eliminado:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_StatusContrato?eliminado=' + eliminado + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_InfoContrato(eliminado:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_InfoContrato?eliminado=' + eliminado + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_SegVisitaCert(eliminado:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_SegVisitaCert?eliminado=' + eliminado, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_OrigenDestino(status:number, extranjera:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_OrigenDestino?status=' + status + '&extranjera=' + extranjera, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  getReporte_TipoUnidad(status:number){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.get(this.url + '/getReporte_TipoUnidad?status=' + status, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }

  updateEmpresaAlerta(obj:any){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userToken}`
    });
    return this._http.post(this.url + '/updateEmpresaAlerta', obj, {headers})
    .toPromise().then(res=>JSON.parse(JSON.stringify(res)));
  }
}
